/* eslint-disable no-console */

import {ParseOdontoDistrictFilterProps} from './types';

const parseOdontoDistrictFilter = ({
	districtName,
	citiesNames,
	stateCode,
}: ParseOdontoDistrictFilterProps) => {
	if (!districtName || !citiesNames || !stateCode) {
		return [];
	}

	const districts = districtName.split(',').map(district => district.trim());
	const cities = citiesNames.split(',').map(city => city.trim());

	if (districts.length !== cities.length) {
		console.error('Districts and cities arrays have different lengths');
		return [];
	}

	return districts.map((district, index) => ({
		uf: stateCode?.toUpperCase() || '',
		cidade: cities[index]?.toUpperCase() || '',
		bairro: district?.toUpperCase() || '',
	}));
};

export {parseOdontoDistrictFilter};
